var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicsvgDownload1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3b",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2370 4616 c-1402 -105 -2289 -1647 -1683 -2926 746 -1573 2960 -1597 3724 -40 714 1453 -412 3089 -2041 2966z m607 -175 c1379 -307 1971 -1967 1096 -3072 -914 -1156 -2749 -897 -3297 466 -577 1435 695 2941 2201 2606z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1807 3332 c-91 -29 -259 -141 -275 -185 -29 -73 50 -125 116 -77 167 123 180 130 266 130 99 0 146 -20 242 -103 75 -66 90 -68 133 -26 117 118 -272 328 -482 261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3087 3332 c-91 -29 -259 -141 -275 -185 -29 -73 50 -125 116 -77 167 123 180 130 266 130 99 0 146 -20 242 -103 75 -66 90 -68 133 -26 117 118 -272 328 -482 261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1391 1969 c-48 -49 -41 -63 114 -223 702 -725 1420 -722 2120 9 145 151 152 165 104 214 -47 46 -52 43 -212 -121 -647 -666 -1215 -677 -1879 -34 -211 204 -202 199 -247 155z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload1);
export default __webpack_public_path__ + "static/media/picsvg_download(1).cb23c65cb3eb3bb0f738653a3c4864a9.svg";
export { ForwardRef as ReactComponent };